import React, { createContext } from "react";

const SongsContext = createContext();

export default SongsContext;
